const name = 'time';
export const INITIALIZE_REQUEST = `${name}/INITIALIZE_REQUEST`;
export const INITIALIZE_SUCCESS = `${name}/INITIALIZE_SUCCESS`;
export const INITIALIZE_FAILURE = `${name}/INITIALIZE_FAILURE`;

export const FETCH_ENTRIES_REQUEST = `${name}/FETCH_ENTRIES_REQUEST`;
export const FETCH_ENTRIES_SUCCESS = `${name}/FETCH_ENTRIES_SUCCESS`;
export const FETCH_ENTRIES_FAILURE = `${name}/FETCH_ENTRIES_FAILURE`;

export const PATCH_REQUEST = `${name}/PATCH_REQUEST`;
export const PATCH_SUCCESS = `${name}/PATCH_SUCCESS`;
export const PATCH_FAILURE = `${name}/PATCH_FAILURE`;

export const DELETE_REQUEST = `${name}/DELETE_REQUEST`;
export const DELETE_SUCCESS = `${name}/DELETE_SUCCESS`;
export const DELETE_FAILURE = `${name}/DELETE_FAILURE`;

export const POST_REQUEST = `${name}/POST_REQUEST`;
export const POST_SUCCESS = `${name}/POST_SUCCESS`;
export const POST_OUT_OF_RANGE_SUCCESS = `${name}/POST_OUT_OF_RANGE_SUCCESS`;
export const POST_FAILURE = `${name}/POST_FAILURE`;

export const SET_PERIOD = `${name}/SET_PERIOD`;

export const TABLE_VIEW = 'TABLE_VIEW';
export const LIST_VIEW = 'LIST_VIEW';
export const VIEW_CONFIG_KEY = 'time.overview.viewStyle';
export const ORDERED_KEY = 'clockCard.entries.orderedColumns';

export const PUNCH_REQUEST = `${name}/PUNCH_REQUEST`;
export const PUNCH_SUCCESS = `${name}/PUNCH_SUCCESS`;
export const PUNCH_FAILURE = `${name}/PUNCH_FAILURE`;

export const OPEN_ENTRY_REQUEST = `${name}/OPEN_ENTRY_REQUEST`;
export const OPEN_ENTRY_SUCCESS = `${name}/OPEN_ENTRY_SUCCESS`;
export const OPEN_ENTRY_FAILURE = `${name}/OPEN_ENTRY_FAILURE`;



// WEBPACK FOOTER //
// ./src/sites/time/constants.js